export const LOCAL_SERVER_PORT = 5000;
export const LOCAL_CDN_SERVER_PORT = 5200;
